import { Box, Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as ListIcon } from "assets/List.svg";
import { ReactComponent as User } from "assets/user.svg";
import { ReactComponent as WarningCircle } from "assets/WarningCircle.svg";

import ThemeContext from "components/app/Context";
import Checkbox from "components/common/Checkbox";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import BasicTable from "components/common/Table";
import ToolTip from "components/common/Tooltip";
import Typography from "components/common/Typography";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { formFilterRequestPayload, getNamesFromHtlId } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { recommendationAccessTypes, responseTypes } from "utils/Types";
import "../../common/Table.scss";
import DeleteSuggestionsDialog from "./DeleteSuggestionsDialog";
import {
  deleteSuggestionAsync,
  fetchSuggestionsDetailsAsync,
  setSelectedSuggestedInncodes
} from "./ManageSuggestions.slice";
import MobileCommonTableForManageSuggestion from "./MobileTableForManageSuggestion";
import { innerTableHeaders } from "./TableHeadersConfig";

const ManageSuggestionTable = (props: any) => {
  const { row, index } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const selectedSuggestedInncodes: any = useAppSelector((state) => state.manageSuggestions.selectedSuggestedInncodes);

  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[filterPage.manageSuggestionsDisplay]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const uploadRecommendationAccess = useAppSelector(
    (state) => state.app.loggedInUserDetails.uploadRecommendationAccess
  );
  const suggestedByDetails = useAppSelector((state) => state.manageSuggestions.suggestedByDetails);

  const [open, setOpen] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState({});

  useEffect(() => {
    if (!row?.history?.length) setOpen(false);
  }, [row]);

  const getPayload = (row: any) => {
    let payload: any = {
      inncode: [row.inncode],
      includeDetail: true
    };
    payload = formattedFilterRequestPayload?.hltId
      ? { ...payload, hltId: formattedFilterRequestPayload?.hltId }
      : payload;
    return payload;
  };

  const getIcon = (suggestedThrough: any) => {
    if (suggestedThrough === "Via Excel File") {
      return ListIcon;
    } else if (suggestedThrough === "User Added") {
      return User;
    }
  };

  const getInnerTableData = (row: any) => {
    dispatch(fetchSuggestionsDetailsAsync(getPayload(row)));
  };

  const onDeleteClickHandler = async (element: any) => {
    const payload = {
      ...formattedFilterRequestPayload,
      inncode: [row.inncode],
      adhocIds: [element.adhocId]
    };
    const response = await dispatch(deleteSuggestionAsync(payload));
    if (response?.payload.status === responseTypes.success) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: "Plan removed from suggestions",
          variant: "success"
        })
      );
      setOpenDeleteDialog({});
    }
  };

  return (
    <>
      {!isMobileScreen ? (
        <React.Fragment key={row.inncode}>
          <TableRow sx={{ "& > *": { borderBottom: "unset" } }} className="sc-table-top-row">
            <TableCell
              component="td"
              scope="row"
              sx={{
                padding: "8px 0 8px 8px",
                width: "12px",
                color: tokens.Text.General.PrimaryHeadline,
                cursor: "pointer"
              }}
            >
              <IconButton
                onClick={() => {
                  if (row?.suggestedPlansCount > 0) {
                    !open && !row?.history?.length && getInnerTableData(row);
                    setOpen(!open);
                  }
                }}
              >
                {open ? <ArrowUp /> : <ArrowDown />}
              </IconButton>
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              className="checkbox-row"
              sx={{
                padding: "8px 16px",
                color: tokens.Text.General.PrimaryHeadline
              }}
            >
              {(uploadRecommendationAccess === recommendationAccessTypes.edit ||
                uploadRecommendationAccess === recommendationAccessTypes.upload) && (
                <Checkbox
                  checked={selectedSuggestedInncodes?.some((el: any) => el === row.inncode)}
                  onChange={(e: any) => {
                    const isChecked = e.target.checked;
                    let payload = selectedSuggestedInncodes && [...selectedSuggestedInncodes];
                    if (isChecked) {
                      payload.push(row.inncode);
                    } else if (!isChecked) {
                      const newData = selectedSuggestedInncodes?.filter((el: any) => el !== row.inncode);
                      payload = newData;
                    }

                    dispatch(setSelectedSuggestedInncodes(payload));
                  }}
                />
              )}
              <Typography variant="body2" showBold>
                {row.inncode}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px 16px",
                color: tokens.Text.General.PrimaryHeadline
              }}
            >
              <Typography>{row.suggestedPlansCount}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px 16px",
                color: tokens.Text.General.PrimaryHeadline
              }}
            >
              <Typography>{row.brandName}</Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "8px 16px",
                color: tokens.Text.General.PrimaryHeadline
              }}
            >
              <Typography variant="body2">{row.region}</Typography>
            </TableCell>
          </TableRow>

          {open && row.history?.length ? (
            <TableRow>
              <TableCell
                style={{ paddingBottom: 0, paddingTop: 0 }}
                colSpan={6}
                sx={{ background: tokens.Background.General.Secondary }}
                className="parent-table-cell"
              >
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <BasicTable
                      sx={{ background: tokens.Background.General.Secondary }}
                      isTablePaginated={false}
                      data={{
                        headers: innerTableHeaders,
                        rows: row?.history?.map((element: any) => {
                          return {
                            data: [
                              {
                                content: element?.priority,
                                subClasses: !element?.applicableForInnCode ? "not-applicable-bg" : ""
                              },
                              {
                                content: (
                                  <div className="vertical-center gap-4">
                                    {!element.applicableForInnCode && (
                                      <ToolTip title="The plan does not apply to this property">
                                        <WarningCircle />
                                      </ToolTip>
                                    )}
                                    <Box
                                      onClick={() => {
                                        if (element.applicableForInnCode) {
                                          dispatch(
                                            setPageFilter({
                                              pageName: filterPage.planProgressFromLibraryDisplay,
                                              modifiedFilter: [
                                                {
                                                  id: 6,
                                                  key: "planSource",
                                                  options: [
                                                    "recommended_default",
                                                    "recommended_criteria",
                                                    "recommended_brand_deadline",
                                                    "recommended_initiative"
                                                  ],
                                                  name: "Plan Source"
                                                }
                                              ]
                                            })
                                          );
                                          navigate(`/plandetails/${element?.cmsId}`, {
                                            state: {
                                              innCode: row?.inncode,
                                              defaultTab: 1
                                            }
                                          });
                                        }
                                      }}
                                      sx={{
                                        textDecoration: "none",
                                        color: tokens.Text.General.PrimaryHeadline,
                                        fontWeight: "700",
                                        cursor: "pointer"
                                      }}
                                    >
                                      <Typography
                                        className={element.applicableForInnCode ? "text-underline" : ""}
                                        variant="body2"
                                        color={tokens.Text.General.PrimaryBody}
                                      >
                                        {element?.planName}
                                      </Typography>
                                    </Box>
                                  </div>
                                )
                              },

                              { content: getNamesFromHtlId([element?.suggestedBy], suggestedByDetails) },
                              { content: element?.suggestedThrough, icon: getIcon(element?.suggestedThrough) },
                              { content: getUIFormatDate(element?.expiryDate) || "-" },

                              {
                                content:
                                  element.suggestedThrough === "User Added" &&
                                  uploadRecommendationAccess === recommendationAccessTypes.upload ? (
                                    <Box sx={{ cursor: "pointer" }} onClick={() => setOpenDeleteDialog(element)}>
                                      <DeleteIcon />
                                    </Box>
                                  ) : (
                                    <></>
                                  )
                              }
                            ]
                          };
                        })
                      }}
                    />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          ) : (
            <></>
          )}
        </React.Fragment>
      ) : (
        <MobileCommonTableForManageSuggestion
          {...props}
          getIcon={getIcon}
          getInnerTableData={getInnerTableData}
          onDeleteClickHandler={onDeleteClickHandler}
          setOpenDeleteDialog={setOpenDeleteDialog}
          openDeleteDialog={openDeleteDialog}
        />
      )}
      {openDeleteDialog ? (
        <DeleteSuggestionsDialog
          setOpenDeleteDialog={setOpenDeleteDialog}
          openDeleteDialog={openDeleteDialog}
          onDeleteClickHandler={onDeleteClickHandler}
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default ManageSuggestionTable;
